module.exports = __webpack_public_path__ + "img/version1.9b9f8a28.jpg";